import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { wayHomeConfig } from '../config/products';

const WayHomePage: React.FC = () => {
  return <ProductPage config={wayHomeConfig} />;
};

export default WayHomePage;

